import React from 'react';
import { ListGroup } from 'react-bootstrap';
import { OrgNameTinType, enums, formatOrgName } from '~/util';
import { EditRole, EntityTypeType, RemoveRole, UserRoleType } from '~/components/Admin';
import { ServicesContext } from '~/services';

interface RoleRowProps {
    role: UserRoleType;
    entityType: EntityTypeType;
}
export function RoleRow({ role, entityType }: RoleRowProps) {
    const servicesContext = React.useContext(ServicesContext);
    const [isRemoving, setIsRemoving] = React.useState(false);
    const [isEditing, setIsEditing] = React.useState(false);
    const isOrgDisabled = entityType === 'organization' && !role[entityType]?.is_enabled;

    return (
        <ListGroup.Item key={role.id}>
            <div className="row align-items-center">
                <div className="col-9">
                    <label
                        className={`form-label${isOrgDisabled ? ' text-secondary fst-italic' : ''}`}
                    >
                        {entityType === 'organization'
                            ? formatOrgName(role[entityType] as OrgNameTinType)
                            : role[entityType]?.name}
                        {isOrgDisabled && ' - Inactive'}
                    </label>
                    {!isEditing &&
                        role[`${entityType}_roles`]?.map((y) => (
                            <div key={y}>Role: {enums(['organization_roles', y]).name}</div>
                        ))}
                    {!isEditing && entityType === 'organization' && (
                        <div>
                            Market(s):{' '}
                            {role?.markets && role?.markets?.length > 0
                                ? role.markets.map((x) => x.name).join(', ')
                                : 'All Markets'}
                        </div>
                    )}
                </div>
                {!isRemoving &&
                    !isEditing &&
                    servicesContext.user.isAdminInOrg(role.organization?.id) && (
                        <div className="col-3">
                            <button
                                type="button"
                                className="pull-right btn btn-danger btn-sm"
                                onClick={() => setIsRemoving(true)}
                                aria-label="Remove"
                            >
                                <i className="fa-solid fa-close" />
                            </button>
                            <button
                                type="button"
                                className="pull-right btn btn-primary btn-sm me-2"
                                onClick={() => setIsEditing(true)}
                                aria-label="Edit"
                            >
                                <i className="fa-solid fa-pencil" />
                            </button>
                        </div>
                    )}
            </div>
            {isEditing && (
                <EditRole role={role} entityType={entityType} setIsEditing={setIsEditing} />
            )}
            {isRemoving && (
                <RemoveRole role={role} entityType={entityType} setIsRemoving={setIsRemoving} />
            )}
        </ListGroup.Item>
    );
}
